import { cellRenderParseDataAndTime } from '../../../utils/functions';

/** Список полей прав роли */
const columnDataGridPermission = [
  {
    dataField: 'permDescription',
    dataType: 'string',
    caption: 'Тип прав',
    width: 200
  },
  {
    dataField: 'valueDescription',
    dataType: 'string',
    caption: 'Значение',
    width: 250
  },
  {
    dataField: 'code',
    dataType: 'string',
    caption: 'Код',
    width: 120
  },
  {
    dataField: 'modUser',
    dataType: 'string',
    caption: 'Изменил',
    width: 200
  },
  {
    dataField: 'modDatetime',
    dataType: 'date',
    caption: 'Время изменения',
    width: 200,
    cellRender: cellRenderParseDataAndTime
  }
];

export default columnDataGridPermission;
